import CryptoJS from "crypto-js";

const getKey = (secretKey: string) => CryptoJS.SHA256(secretKey);

export const encryptData = <T>(data: T, secretKey: string): string | null => {
    try {
        if (!secretKey || data === undefined || data === null) return null;

        const key = getKey(secretKey);
        const iv = CryptoJS.lib.WordArray.random(16);

        const encrypted = CryptoJS.AES.encrypt(
            JSON.stringify(data),
            key,
            { iv }
        );

        return JSON.stringify({
            iv: iv.toString(),
            value: encrypted.toString(),
        });
    } catch (error) {
        console.error("Encryption error:", error);
        return null;
    }
};

export const decryptData = <T>(
    ciphertext: string,
    secretKey: string
): T | null => {
    try {
        if (!secretKey || !ciphertext) return null;

        const key = getKey(secretKey);
        const parsed = JSON.parse(ciphertext);

        if (!parsed?.iv || !parsed?.value) return null;

        const bytes = CryptoJS.AES.decrypt(parsed.value, key, {
            iv: CryptoJS.enc.Hex.parse(parsed.iv),
        });

        const decrypted = bytes.toString(CryptoJS.enc.Utf8);

        return decrypted ? (JSON.parse(decrypted) as T) : null;
    } catch (error) {
        console.error("Decryption error:", error);
        return null;
    }
};